import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import { store } from './store/store';
import { routes } from './routes';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import BootstrapVue from "bootstrap-vue";
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./App.css";
import "tachyons";
import Vuelidate from "vuelidate";
import VueGtag from "vue-gtag";
import * as country_based_data from './JS/CountryBasedData';
import moment from "moment";

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.use(VuetifyDialog);
Vue.use(Vuelidate);
Vue.use(Toast, {
  maxToasts: 100,
  transition: 'Vue-Toastification__bounce',
  transitionDuration: 750,
  draggable: true,
  draggablePercent: 0.6,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  closeOnClick: true,
  timeout: 1000,
  container: document.body,
  toastClassName: [],
  bodyClassName: [],
  hideProgressBar: false,
  hideCloseButton: false,
  icon: true
});

Vue.filter("formatDate", function (value) {
  if (value) return moment(value).format("MM/DD/YYYY");
});

//Vue gtag is to add google analytics script.
Vue.use(VueGtag, {
  config: { id: "UA-64586946-15" }
});

//Change Country code for northerncontainersales.com to CA. 
const servername = window.location.hostname;
var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/png';
link.rel = 'icon';
//Change favicon based on country code.
if (servername.includes('northerncontainersales')) {
  link.href = [country_based_data.CAFavicon];
  store.state.country_code = 'CA'
}
else {
  link.href = [country_based_data.USFavicon];
  store.state.country_code = 'US'
}
document.getElementsByTagName('head')[0].appendChild(link);


//Initialize cart from local storage.
store.state.containerdetailes =
  JSON.parse(localStorage.getItem("containerdetailes")) || new Array(0);
//Initialize sales price response from local storage.
store.state.containers_list =
  JSON.parse(localStorage.getItem("containers_list")) || null;
//Initialize zipcode.
store.state.zipcode = localStorage.zipcode || "";
//Initialize terms and conditions checkbox
store.state.termsCheckbox =
  JSON.parse(localStorage.getItem("termsCheckbox")) || false;
/*Current survey object has the info of current item for which progress bar is displayed 
on the forms page*/
store.state.currentSurveyObject =
  JSON.parse(localStorage.getItem("currentSurveyObject")) || null;
//get predelivery data from session storage
store.state.predelivery =
  JSON.parse(sessionStorage.getItem("predelivery")) ||
  store.state.predelivery;
//get prepickup data from session storage
store.state.prepickup =
  JSON.parse(sessionStorage.getItem("prepickup")) ||
  store.state.prepickup;


const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  store,
  router,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')

